var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      !_vm.hideSelect
        ? _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Препарат")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex align-items-center" }, [
                    _vm.selectedDrug && _vm.selectedDrug.id
                      ? _c("i", {
                          staticClass: "icon-fa icon-fa-edit openEditDrugIcon",
                          on: {
                            click: function ($event) {
                              return _vm.openDrugEdit(_vm.selectedDrug.id)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex-grow-1" },
                      [
                        _c("DrugSearchNew", {
                          attrs: {
                            onSelect: _vm.selectDrug,
                            searchOptions: { details: true },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Проект")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedProject,
                          expression: "selectedProject",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedProject = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.loadDrugData,
                        ],
                      },
                    },
                    _vm._l(_vm.activeProjectsToEdit, function (project) {
                      return _c("option", { domProps: { value: project.id } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(project.title) +
                            "\n            "
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      _vm.drugData
        ? [
            _vm.drugSiteData
              ? _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("p", [
                      _vm._v("Данные на сайте: "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.drugSiteData.link,
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(_vm.drugSiteData.title))]
                      ),
                      _vm._v(
                        "\n          (" +
                          _vm._s(_vm.selectedDrug && _vm.selectedDrug.id) +
                          ")\n          "
                      ),
                      _c(
                        "span",
                        {
                          class: {
                            badge: true,
                            "badge-success": _vm.drugActiveOnProject,
                            "badge-warning": !_vm.drugActiveOnProject,
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.drugActiveOnProject ? "Активен" : "Не активен"
                            )
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("SiteDrugEditBlock", {
              attrs: {
                allData: _vm.allData,
                drug: _vm.drugData,
                selectedAnalogDrugs: _vm.analogDrugs,
                selectedAnalogTableDrugs: _vm.analogTableDrugs,
                selectedOtherForms: _vm.otherForms,
                reloadDrug: _vm.loadDrugData,
                siteId: _vm.selectedProject,
                siteSelects: { ...(_vm.siteData || {}), ..._vm.drugSiteData },
                drugDetails: _vm.drugData?.site_details ?? [],
                details: _vm.siteDetails,
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-info" }, [
      _c("h5", [_vm._v("Выбор препарата")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }